module.exports = __webpack_public_path__ + "svg/context.svg?d998d2dc88d9a8ca42a4362ae111b908";